export const keys = Object.keys;
export const values = Object.values;
export const entries = Object.entries;
export const nonNullable = (value) => value !== null && value !== undefined;
//# sourceMappingURL=utils.js.map